import React from 'react';

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(2, 8, 23, 0.78)',
  backdropFilter: 'blur(2px)',
  zIndex: 2147483647,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 16,
};

const cardStyle = {
  width: '100%',
  maxWidth: 520,
  borderRadius: 14,
  border: '1px solid rgba(56, 189, 248, 0.35)',
  background:
    'linear-gradient(180deg, rgba(15,23,42,0.98), rgba(2,6,23,0.98))',
  boxShadow: '0 24px 64px rgba(2, 8, 23, 0.6)',
  padding: 16,
  color: '#e2e8f0',
};

const titleStyle = {
  margin: 0,
  fontSize: 18,
  fontWeight: 700,
  color: '#f8fafc',
};

const subStyle = {
  marginTop: 8,
  fontSize: 13,
  lineHeight: 1.45,
  color: '#cbd5e1',
};

const metaStyle = {
  marginTop: 10,
  fontSize: 13,
  color: '#94a3b8',
};

const actionRowStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  marginTop: 14,
};

const closeStyle = {
  marginTop: 12,
  background: 'transparent',
  border: 'none',
  color: '#94a3b8',
  cursor: 'pointer',
  fontSize: 13,
  padding: '6px 0',
  textAlign: 'left',
};

const primaryCtaStyle = {
  background: 'linear-gradient(120deg, #5ad4ff, #1ee3b7 75%)',
  color: '#04141c',
  opacity: 1,
};

const primaryCtaLabelStyle = {
  color: '#04141c',
  opacity: 1,
  fontWeight: 800,
  position: 'relative',
  zIndex: 1,
};

export default function BuyerPendingConfirmationGateModal({
  open,
  blockingOrder = null,
  contextLabel = 'Before continuing',
  busy = false,
  error = '',
  onConfirm = () => {},
  onDispute = () => {},
  onMessage = () => {},
  onClose = () => {},
}) {
  if (!open) return null;
  const effectiveStatus = String(
    blockingOrder?.effectiveSettlementStatus ||
      blockingOrder?.settlementStatus ||
      '',
  ).toLowerCase();
  const canConfirm = effectiveStatus === 'confirmation_requested';
  const canReportProblem = canConfirm;
  const offeringTitle = blockingOrder?.offering?.title || 'this order';
  const sellerHandle = blockingOrder?.seller?.playerId
    ? `@${blockingOrder.seller.playerId}`
    : 'the seller';

  return (
    <div style={overlayStyle} role="dialog" aria-modal="true">
      <div style={cardStyle} data-testid="pending-confirmation-gate">
        <h3 style={titleStyle}>Resolve pending delivery confirmation</h3>
        <div style={subStyle}>
          {contextLabel}: resolve your pending order first.
        </div>
        <div style={metaStyle}>
          Blocking order: <strong>{offeringTitle}</strong> with {sellerHandle}
        </div>
        <div style={metaStyle}>
          Settlement state: {effectiveStatus || 'unknown'}
        </div>
        {!canConfirm ? (
          <div style={metaStyle}>
            Confirmation is unavailable in this state. Contact the seller before
            continuing.
          </div>
        ) : null}
        {error ? (
          <div style={{ marginTop: 10, color: '#fca5a5', fontSize: 13 }}>
            {error}
          </div>
        ) : null}
        <div style={actionRowStyle}>
          {canConfirm ? (
            <button
              type="button"
              className="localops-btn"
              style={primaryCtaStyle}
              disabled={busy}
              onClick={onConfirm}
            >
              <span style={primaryCtaLabelStyle}>
                Confirm Delivery &amp; Release Payout
              </span>
            </button>
          ) : null}
          {canReportProblem ? (
            <button
              type="button"
              className="localops-btn localops-btn--ghost"
              disabled={busy}
              onClick={onDispute}
            >
              Report a problem
            </button>
          ) : null}
          <button
            type="button"
            className="localops-btn localops-btn--ghost"
            disabled={busy}
            onClick={onMessage}
          >
            Message Seller
          </button>
        </div>
        <button type="button" style={closeStyle} disabled={busy} onClick={onClose}>
          Not now
        </button>
      </div>
    </div>
  );
}
